import React from 'react';
import SelectEngine from '../engine/SelectEngine';
import _OutlinedInput from '../OutlinedInput';
import styled from 'styled-components/macro';
import { Button, Switch } from '@material-ui/core';
import Colors from '../../internal-components/Colors';
import BellIcon from '@material-ui/icons/Notifications';

const OutlinedInput = styled(_OutlinedInput)`
  && {
    height: 1rem;
    margin-right: 1rem;
    min-width: 5rem;
    width: 5rem;
  }
`;

const TitleDiv = styled.div`
  font-weight: 500;
`;

const BlueBell = styled(BellIcon)`
  && {
    color: ${Colors.PRIMARY};
    height: 1rem;
    line-height: 1rem;
  }
`;

const OnDueDateContainer = styled.span`
  margin-left: 1.5rem;
`;

const GridOuter = styled.div`
  display: grid;
  grid-template-columns: 50px 100px 400px 50px;
  grid-template-rows: auto;
`;

const GridCell = styled.div`
  align-self: ${({ $top }) => ($top ? 'top' : 'center')};
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  padding-top: ${({ $top }) => ($top ? '12px' : null)};
`;

const TopContainer = styled.div`
  display: flex;
`;

const AddReminderContainer = styled.div`
  && {
    display: flex;
    flex: 1;
    justify-content: end;
  }
`;

const BlueLinkButton = styled(Button)`
  && {
    color: ${Colors.PRIMARY};
    text-transform: none;
  }
`;

const TaskFrequencyDueView = props => {
  return (
    <div>
      <TopContainer>
        <div>
          <TitleDiv>When a task is due</TitleDiv>
          <div>Note: Email reminders are sent at X am.</div>
        </div>
        <AddReminderContainer>
          <BlueLinkButton onClick={props.onAddReminderClicked}>
            + Add a reminder
          </BlueLinkButton>
        </AddReminderContainer>
      </TopContainer>
      <div>
        <div>
          <BlueBell />
          <OnDueDateContainer>On due date</OnDueDateContainer>
          <Switch
            checked={props.onDueDate}
            onChange={props.onToggleOnDueDate}
            color="primary"
          />
        </div>
      </div>
      <GridOuter>
        {props.reminders.map((one, k) => (
          <React.Fragment key={k}>
            <GridCell>
              <BlueBell />
            </GridCell>
            <GridCell>
              <OutlinedInput
                numeric
                value={one.reminderCount}
                onChange={e => {
                  props.updateReminderCount(k, e.target.value || 0);
                }}
              />
            </GridCell>
            <GridCell>
              <SelectEngine
                options={[
                  { text: 'Days', value: 'days' },
                  { text: 'Weeks', value: 'weeks' },
                  { text: 'Months', value: 'months' }
                ]}
                value={one.reminderUnit}
                onChange={v => {
                  props.updateReminderUnit(k, v);
                }}
              ></SelectEngine>{' '}
              after due date
            </GridCell>
            <GridCell>
              <BlueLinkButton
                onClick={() => {
                  props.deleteReminder(k);
                }}
              >
                x
              </BlueLinkButton>
            </GridCell>
          </React.Fragment>
        ))}
      </GridOuter>
    </div>
  );
};

export default TaskFrequencyDueView;
